import { render, staticRenderFns } from "./remnantOrder1.vue?vue&type=template&id=9bd61c14&scoped=true&"
import script from "./remnantOrder1.vue?vue&type=script&lang=js&"
export * from "./remnantOrder1.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder1.vue?vue&type=style&index=0&id=9bd61c14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd61c14",
  null
  
)

export default component.exports